import { hexToRgba, rgbaToHexa } from '@meitu/saas-colors';
import { TextMarkStruct, TextMarkSvgSupportPath } from '@meitu/saas-editor-core/es/layers/text-layer/types/text-mark';
import { getVectorTextFromCache } from '@meitu/saas-editor-core/es/utils/file-kit';

export const TextMarkDefaultText = '划重点';

export const TextMarkDefaultFontFamily = 'Poppins-Medium';

// 默认舞台尺寸
export const TextMarkDefaultStage = {
    width: 500,
    height: 500,
};

// 缩略图尺寸
export const TextMarkThumbnailSize = {
    width: 230,
    height: 230,
};

export const SizeRange = [
    {
        label: '最小',
        value: 1,
    },
    {
        label: '默认',
        value: 50,
    },
    {
        label: '最大',
        value: 100,
    },
];
export const MarkPosition = [
    {
        label: '居下',
        value: 'bottom',
    },
    {
        label: '居中',
        value: 'center',
    },
    {
        label: '居上',
        value: 'top',
    },
];

export const MarKType = [
    {
        label: '长度拉伸',
        value: 'stretch',
    },
    {
        label: '背景填充',
        value: 'cover',
    },
    {
        label: '单字应用',
        value: 'use',
    },
    {
        label: '路径重复',
        value: 'repeat',
    },
    {
        label: '路径拼接',
        value: 'combined',
    },
];

export const defaultTextMark: TextMarkStruct['data'] = {
    type: 'cover',
    defaultColor: '',
    defaultFontSize: 80,
    position: 'center',
    enableSize: false,
    enableOpacity: true,
    sizeRange: [],
    src: '',
    repeatPath: '',
    offset: {
        x: 0,
        y: 0,
    },
    padding: {
        x: 0,
        y: 0,
    },
};

export const setTextMarkSvg = (textMark: TextMarkStruct, replaceId?: string) => {
    const textMarkResource = window.localStorage.getItem('textMarkResource');
    if (textMarkResource) {
        const textMarkResourceList = JSON.parse(textMarkResource);
        const index = textMarkResourceList.findIndex(
            (item: TextMarkStruct) => item.materialId == (replaceId ?? textMark.materialId),
        );
        if (index !== -1) {
            textMarkResourceList[index] = textMark;
        } else {
            textMarkResourceList.push(textMark);
        }
        window.localStorage.setItem('textMarkResource', JSON.stringify(textMarkResourceList));
    } else {
        window.localStorage.setItem('textMarkResource', JSON.stringify([textMark]));
    }
};

export const getSvgElement = (url: string) => {
    const svgText = getVectorTextFromCache(url);
    if (!svgText) return null;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, 'image/svg+xml');
    return doc.documentElement;
};

export const getSvgDefaultData = (url: string) => {
    const svgElement = getSvgElement(url);
    if (!svgElement) return {};

    const shapeElements = TextMarkSvgSupportPath.length
        ? svgElement.querySelectorAll(TextMarkSvgSupportPath.join(','))
        : [];

    let defaultColor = '';
    let strokeWidth = 0;

    for (let index = 0; index < shapeElements.length; index++) {
        const shape = shapeElements[index];
        const fill = shape.getAttribute('fill');
        const stroke = shape.getAttribute('stroke');
        const svgStrokeWidth = shape.getAttribute('stroke-width');
        if (fill && fill !== 'none') {
            defaultColor = rgbaToHexa(hexToRgba(fill));
        } else if (stroke && stroke !== 'none') {
            defaultColor = rgbaToHexa(hexToRgba(stroke));
        }
        if (svgStrokeWidth) {
            strokeWidth = +svgStrokeWidth;
        }
    }
    return { defaultColor, strokeWidth, enableSize: strokeWidth > 0 };
};

export const getSvgPathD = (url: string) => {
    const svgElement = getSvgElement(url);
    if (!svgElement) return '';
    const pathD = svgElement.querySelector('path')?.getAttribute('d');
    return pathD;
};

// 提取可重复的 pathD，只适用于 c 和 l 的 pathD
export const getRepeatPathD = (pathD: string) => {
    const repeatPathData = pathD.split(/(?=c|l)/g);
    if (repeatPathData.length) {
        return repeatPathData[repeatPathData.length - 1];
    }
};
